import axios from "axios";

async function getAttributesTypesApi() {
    return axios({
        method: 'GET',
        url: '/api/v1/attributes'
    });
}

/**
 * Create attribute type
 * @param name
 */

async function postAttributeTypeApi(name: string){
    return axios({
        method:"POST",
        url: `/api/v1/attributes`,
        data: {name}
    })
}

export {
    getAttributesTypesApi,
    postAttributeTypeApi,
}
